import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TimeField } from "@/components/DateTimeField";

const ChecksGrid = ({ items, value, onChange, testid }) => (
  <div className="grid max-h-56 grid-cols-2 gap-1.5 overflow-y-auto rounded-lg border border-border p-2" data-testid={testid}>
    {items.map((it) => (
      <label key={it.v} className="flex cursor-pointer items-center gap-2 text-sm">
        <Checkbox checked={value.includes(it.v)} onCheckedChange={(c) => onChange(c ? [...value, it.v] : value.filter((x) => x !== it.v))} />
        {it.l}
      </label>
    ))}
  </div>
);

const RecipientsInput = ({ value, onChange }) => {
  const [txt, setTxt] = useState("");
  const add = () => {
    const parts = txt.split(/[,;\s]+/).map((p) => p.trim()).filter(Boolean);
    if (parts.length) onChange([...new Set([...value, ...parts])]);
    setTxt("");
  };
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {value.map((r) => (
          <span key={r} className="inline-flex items-center gap-1 rounded-full border border-border bg-secondary px-2 py-0.5 text-xs" data-testid={`rem-recipient-${r}`}>
            {r}<button type="button" onClick={() => onChange(value.filter((x) => x !== r))} className="text-muted-foreground hover:text-destructive">×</button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <Input value={txt} onChange={(e) => setTxt(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
          onBlur={add} placeholder="nome@dominio.it — Invio per aggiungere" data-testid="rem-recipient-input" />
        <Button type="button" variant="outline" onClick={add} data-testid="rem-recipient-add">Aggiungi</Button>
      </div>
    </div>
  );
};

export const ReminderForm = ({ form, setForm, statusOptions, categories }) => {
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v?.target ? v.target.value : v }));
  return (
    <div className="space-y-4">
      <div className="space-y-1.5"><Label>Nome promemoria</Label><Input value={form.name} onChange={set("name")} placeholder="Delivery da sbloccare da 2 giorni" data-testid="rem-name" /></div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label>Sezione</Label>
          <Select value={form.area || "all"} onValueChange={(v) => set("area")(v === "all" ? "" : v)}>
            <SelectTrigger data-testid="rem-area"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutte</SelectItem>
              <SelectItem value="ticket">Ticket - Delivery & Assurance</SelectItem>
              <SelectItem value="manutenzione">Ticket - Manutenzione</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Aging (giorni nello stato attuale)</Label>
          <div className="flex gap-2">
            <Select value={form.aging_op} onValueChange={set("aging_op")}>
              <SelectTrigger className="w-40" data-testid="rem-aging-op"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="gte">almeno</SelectItem><SelectItem value="eq">esattamente</SelectItem></SelectContent>
            </Select>
            <Input type="number" min={0} value={form.aging_days} onChange={(e) => set("aging_days")(parseInt(e.target.value) || 0)} className="w-24" data-testid="rem-aging-days" />
            <span className="self-center text-sm text-muted-foreground">gg</span>
          </div>
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5"><Label>Stati (vuoto = tutti)</Label><ChecksGrid items={statusOptions} value={form.statuses} onChange={set("statuses")} testid="rem-statuses" /></div>
        <div className="space-y-1.5"><Label>Categorie (vuoto = tutte)</Label><ChecksGrid items={categories.map((c) => ({ v: c, l: c }))} value={form.categories} onChange={set("categories")} testid="rem-categories" /></div>
      </div>
      <div className="space-y-1.5"><Label>Invia ogni giorno alle</Label><div className="w-40"><TimeField value={form.time} onChange={set("time")} testid="rem-time" /></div></div>
      <div className="space-y-1.5"><Label>Destinatari</Label><RecipientsInput value={form.recipients} onChange={set("recipients")} /></div>
      <div className="space-y-1.5"><Label>Oggetto</Label><Input value={form.subject} onChange={set("subject")} placeholder="{numero} ticket in {stato} da almeno {giorni} giorni" data-testid="rem-subject" /></div>
      <div className="space-y-1.5">
        <Label>Testo</Label>
        <Textarea rows={3} value={form.body} onChange={set("body")} placeholder="Buongiorno, i seguenti ticket richiedono attenzione:" data-testid="rem-body" />
        <p className="text-xs text-muted-foreground">Segnaposto: {"{nome}"} {"{numero}"} {"{giorni}"} {"{stato}"}. In coda alla mail viene aggiunto l'elenco dei ticket con link.</p>
      </div>
    </div>
  );
};
